import React, { useState, useEffect, useCallback } from "react";
import { producaov2 as api } from "../../../../services/apis";
import { isAuthAdmin } from "../../../../services/auth";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Dropdown, Icon } from "semantic-ui-react";
import {
  ContainerInputSearch,
  Input,
  SemanticTable,
  StyledLabel,
  StyledButton,
  Footer,
  Buttons,
} from "./styles";

const Formulario = () => {
  const [indicacoesFiltradas, setIndicacoesFiltradas] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [parceiro, setParceiro] = useState(null);

  useEffect(() => {
    loadAuth();
    listarIndicacoes();
    getTotalPages();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const getTotalPages = async () => {
    const response = await api.get("/inscricoes-eventos");
    const totalEntries = response.data.inscricoesEventosCount;
    let pages = 1;

    if (totalEntries % 25 === 0) {
      pages = totalEntries / 25;
    } else {
      pages = Math.ceil(totalEntries / 25);
    }

    setTotalPage(pages);
  };

  const listarIndicacoes = async (
    pageNumber = 1,
    eventoSearch = "",
    inputSearch = "",
    parceiroSearch = null,
    ordenado = null
  ) => {
    try {
      if (parceiro) {
        parceiroSearch = parceiro;
      }

      let response;
      if (eventoSearch === "" && inputSearch === "") {
        if (ordenado !== null) {
          if (parceiroSearch) {
            response = await api.get(
              `/inscricoes-eventos?page=${pageNumber}&parceiro=${parceiroSearch}`
            );
          } else {
            response = await api.get(`/inscricoes-eventos?page=${pageNumber}`);
          }
          let logs = {
            local: "eventos",
            texto: `listou as indicações de eventos`,
          };
          await api.post("system_logs", { acao: JSON.stringify(logs) });

          let indicacoesOrdenadas = [];

          if (ordenado) {
            indicacoesOrdenadas = response.data[0].sort(function (a, b) {
              return a.indicacoes - b.indicacoes;
            });
          } else {
            indicacoesOrdenadas = response.data[0].sort(function (a, b) {
              return b.indicacoes - a.indicacoes;
            });
          }

          setIndicacoesFiltradas(indicacoesOrdenadas);

          return;
        } else {
          response = await api.get(`/inscricoes-eventos?page=${pageNumber}`);
        }
      }
      if (eventoSearch === "" && pageNumber === 0) {
        response = await api.get(`/inscricoes-eventos?search=${inputSearch}`);
      }
      //if (inputSearch === '' && pageNumber === 0) {
      //    response = await api.get(`/inscricoes-eventos?event=${eventoSearch}`);
      //}

      let logs = { local: "eventos", texto: `listou as indicações de eventos` };
      await api.post("system_logs", { acao: JSON.stringify(logs) });

      setIndicacoesFiltradas(response.data[0]);
    } catch (err) {
      if (err) {
        toast.error(
          "Seu login expirou, por gentileza, realize o mesmo novamente",
          {
            position: "bottom-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          }
        );
      }
    }
  };

  const nextPage = useCallback(() => {
    if (page === totalPage) return;

    const pageNumber = page + 1;

    setPage(pageNumber);
    listarIndicacoes(pageNumber);
  }, [page, totalPage, listarIndicacoes]);

  const previousPage = useCallback(() => {
    if (page === 1) return;

    const pageNumber = page - 1;

    setPage(pageNumber);
    listarIndicacoes(pageNumber);
  }, [page, listarIndicacoes]);

  const filterBySearch = (inputValue) => {
    if (inputValue === "") {
      listarIndicacoes(1, "", inputValue);
      return;
    }
    listarIndicacoes(0, "", inputValue);
  };

  const handleParceriaChange = useCallback((e, { options, value }) => {
    setParceiro(value);
    listarIndicacoes(1, "", "", value, false);
  }, []);

  return (
    <>
      <StyledLabel>Tipo de parceiro</StyledLabel>
      <Dropdown
        fluid
        selection
        options={[
          { key: 0, text: `Embaixadores - 1`, value: 1 },
          { key: 1, text: `Movimentos estudantis - 2`, value: 2 },
        ]}
        onChange={handleParceriaChange}
        value={parceiro}
      />
      <StyledLabel>Filtrar por nome/ID</StyledLabel>
      <ContainerInputSearch className="ui fluid left icon input">
        <Input
          type="search"
          placeholder="Pesquisar indicação"
          onKeyPress={(e) =>
            e.key === "Enter" && filterBySearch(e.target.value)
          }
        />
        <Icon name="search icon" />
      </ContainerInputSearch>

      <StyledLabel>Ordenar por:</StyledLabel>
      <Buttons>
        <StyledButton
          onClick={() => {
            listarIndicacoes(1, "", "", null, false);
          }}
        >
          <i class="plus icon" />
          Mais indicações
        </StyledButton>
        <StyledButton
          onClick={() => {
            listarIndicacoes(1, "", "", null, true);
          }}
        >
          <i class="minus icon" />
          Menos indicações
        </StyledButton>
      </Buttons>

      <SemanticTable size="big" celled>
        <SemanticTable.Header>
          <SemanticTable.Row>
            <SemanticTable.HeaderCell>ID</SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell>Nome</SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell>E-mail</SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell>Evento inscrito</SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell>
              Data de cadastro
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell>
              Tipo de parceria
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell>Indicações</SemanticTable.HeaderCell>
          </SemanticTable.Row>
        </SemanticTable.Header>

        <SemanticTable.Body>
          {indicacoesFiltradas.map((indicacao, index) => (
            <SemanticTable.Row>
              <SemanticTable.Cell> {indicacao.id} </SemanticTable.Cell>
              <SemanticTable.Cell> {indicacao.nome} </SemanticTable.Cell>
              <SemanticTable.Cell> {indicacao.email} </SemanticTable.Cell>
              <SemanticTable.Cell> {indicacao.id_evento} </SemanticTable.Cell>
              <SemanticTable.Cell>
                {" "}
                {indicacao.data_cadastro}{" "}
              </SemanticTable.Cell>
              <SemanticTable.Cell> {indicacao.parceiro} </SemanticTable.Cell>
              <SemanticTable.Cell> {indicacao.indicacoes} </SemanticTable.Cell>
            </SemanticTable.Row>
          ))}
        </SemanticTable.Body>

        <SemanticTable.Footer>
          <SemanticTable.Row>
            <SemanticTable.HeaderCell colSpan="7">
              <Footer>
                <StyledButton onClick={previousPage}>
                  <Icon name="chevron left" />
                  Página Anterior
                </StyledButton>
                <StyledButton onClick={nextPage}>
                  Próxima Página
                  <Icon name="chevron right" />
                </StyledButton>
              </Footer>
            </SemanticTable.HeaderCell>
          </SemanticTable.Row>
        </SemanticTable.Footer>
      </SemanticTable>
    </>
  );
};

export default Formulario;
